import { Component, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { AuthenticationService } from "src/app/auth/authentication.service";

@Component({
    selector: "app-completion-form",
    templateUrl: "./completion-form.component.html",
    styleUrls: ["./completion-form.component.scss"],
    standalone: false
})
export class CompletionFormComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  data: any;
  dateFormat!: string;
  timezone!: string;

  // ── MIGRATED: replaced p-gmap options/overlays with @angular/google-maps equivalents ──
  /** Bound to <google-map [center]> */
  mapCenter: google.maps.LatLngLiteral = { lat: 51.678418, lng: 7.809007 };

  /** Bound to <google-map [zoom]> */
  mapZoom: number = 12;

  /** Bound to <google-map [options]> */
  mapOptions: google.maps.MapOptions = { scrollwheel: true };

  /** Data-driven markers rendered via <map-marker *ngFor> */
  markers: { position: google.maps.LatLngLiteral; options: google.maps.MarkerOptions }[] = [];
  // ──────────────────────────────────────────────────────────────────────────────────────

  translate: any;

  constructor(
    public modalRef: BsModalRef,
    private auth: AuthenticationService,
    private languageTranslateService: LanguageTranslateService
  ) {
    super();
  }

  ngOnInit() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => {
      if (Object.keys(data).length != 0) {
        this.translate = data;
      }
    }));

    console.log("DATA", this.data);
    this.dateFormat = localStorage.getItem("date_format")!;
    this.timezone = this.auth.getUserTimezone();

    if (
      this.data &&
      this.data.jobOrderCompletionRecordVm &&
      this.data.jobOrderCompletionRecordVm.locationLat &&
      this.data.jobOrderCompletionRecordVm.locationLon
    ) {
      const lat = this.data.jobOrderCompletionRecordVm.locationLat;
      const lng = this.data.jobOrderCompletionRecordVm.locationLon;

      // ── MIGRATED: set data-driven properties instead of constructing a
      //              native google.maps.Marker and passing it to p-gmap ──────
      this.mapCenter = { lat, lng };
      this.markers = [
        {
          position: { lat, lng },
          options: { title: "location" },
        },
      ];
      // ───────────────────────────────────────────────────────────────────────
    }
  }

  push(obs: any) {
    super.push(obs);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}